import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M1 2.5H9.48063L11.4806 5H23V12.8464C21.8077 11.4127 20.0104 10.5 18 10.5C14.4101 10.5 11.5 13.4101 11.5 17C11.5 18.5085 12.0139 19.897 12.8762 21H1V2.5Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M18.9999 13.126V11.75H16.9999V13.126C16.285 13.31 15.6474 13.6867 15.1458 14.1975L13.9533 13.509L12.9533 15.241L14.1449 15.929C14.0504 16.2699 13.9999 16.629 13.9999 17C13.9999 17.371 14.0504 17.7301 14.1449 18.071L12.9533 18.759L13.9533 20.491L15.1458 19.8025C15.6474 20.3133 16.285 20.69 16.9999 20.874V22.25H18.9999V20.874C19.7149 20.69 20.3525 20.3133 20.854 19.8025L22.0466 20.491L23.0466 18.759L21.855 18.071C21.9494 17.7301 21.9999 17.371 21.9999 17C21.9999 16.629 21.9494 16.2699 21.855 15.929L23.0466 15.241L22.0466 13.509L20.854 14.1975C20.3525 13.6867 19.7149 13.31 18.9999 13.126ZM16.2852 15.97C16.6351 15.3888 17.2721 15 17.9999 15C18.7278 15 19.3648 15.3888 19.7147 15.97L19.7512 16.0332C19.9097 16.3198 19.9999 16.6493 19.9999 17C19.9999 17.3507 19.9097 17.6802 19.7512 17.9668L19.7147 18.03C19.3648 18.6112 18.7278 19 17.9999 19C17.2721 19 16.6351 18.6112 16.2852 18.03L16.2487 17.9667C16.0902 17.6802 15.9999 17.3506 15.9999 17C15.9999 16.6494 16.0902 16.3198 16.2487 16.0333L16.2852 15.97Z"}}]};

const FolderSettingFilled = Vue.extend<IconProps>({
  name: 'FolderSettingFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'folder-setting-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default FolderSettingFilled;
